var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.822 22.5126C44.822 33.6988 36.5326 42.9466 25.764 44.4473C24.7571 44.587 23.7269 44.6599 22.6812 44.6599C21.4742 44.6599 20.2889 44.5637 19.1346 44.3775C8.5925 42.6797 0.540466 33.5358 0.540466 22.5126C0.540466 10.2805 10.4542 0.36377 22.6828 0.36377C34.9113 0.36377 44.8251 10.2805 44.8251 22.5126H44.822Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52016 10.1315L19.7318 23.7883L9.45654 34.8922H11.7698L20.7666 25.171L28.0352 34.8922H35.9057L25.12 20.4672L34.6847 10.1315H32.3715L24.0867 19.0844L17.3922 10.1315H9.52169H9.52016ZM12.9209 11.8355H16.5358L32.5018 33.1882H28.8869L12.9209 11.8355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.43f4baa3802c4984fd4cf8e62373d5d2.svg";
export { ForwardRef as ReactComponent };